import script from "./OperateGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./OperateGuide.vue?vue&type=script&setup=true&lang=js"

import "./OperateGuide.vue?vue&type=style&index=0&id=ee5d53be&lang=less&scoped=true"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee5d53be"]])

export default __exports__